import React, { useState } from "react";
import "./Header.scss";

import logo from "../../assets/img/logo.svg";
import location from "./assets/img/location.svg";
import MobileMenu from "../MobileMenu";

const Header = () => {
  const [show_menu, set_show_menu] = useState(false);

  const toggle = () => {
    if (show_menu) {
      document.body.classList.remove("fixed");
      document.body.style.overflow = "";
    } else {
      document.body.classList.add("fixed");
      document.body.style.overflow = "hidden";
    }
    set_show_menu(!show_menu);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-wrapper">
          <a
            href="http://bit.ly/splat_logo"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img className="logo header__logo" src={logo} alt="Логотип SPLAT" />
          </a>
          <nav className="header-nav">
            <a className="header-nav__link" href="#facts">
              Факты
            </a>
            <a className="header-nav__link" href="#lifehacks">
              Блогеры
            </a>
             
            <a className="header-nav__link" href="#test">
              Пройдите тест
            </a>
          </nav>

          <a href="#location" className="header__button">
            <img
              className="header__button-image"
              src={location}
              alt="Где сдать щётку?"
            />{" "}
            Где сдать щётку?
          </a>

          <button onClick={toggle} className="header-menu__button"></button>
        </div>
      </div>
      <MobileMenu toggle={toggle} show={show_menu} />
    </header>
  );
};

export default Header;
